export const projectsSlashWorkspaces = (projects, workspaces, flag = false) => {
  return `${projects} / ${projects === 0 ? 0 : flag?"x":workspaces}`;
};
